/** Two cargo ships — common freight UI mark for multi-carrier (no official logo exists). */
export default function MultiCarrierIcon({ className = "w-7 h-7" }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden
        >
            <g opacity="0.5">
                <path d="M2 10.8h5.2l1.1-2.1H11" />
                <path d="M2.2 10.8 3.3 14.2H10" />
                <path d="M6.1 10.8V8.6h2.1l.5 2.2" />
            </g>
            <path d="M6.2 16.6h10.6l2.1-5.4H8.6z" />
            <path d="M13.2 11.2V7.8h3.1l1 3.4" />
            <path d="M5.4 19c.5.4 1.15.75 2.25.75 2.15 0 2.15-1.55 4.3-1.55s2.15 1.55 4.3 1.55c1.1 0 1.75-.35 2.25-.75" />
        </svg>
    );
}
